// services/api/axiosInstance.ts
import axios from 'axios';
import requestInterceptor from '../interceptors/requestInterceptor';
import responseInterceptor from '../interceptors/responseInterceptor';
import { BASE_URL } from '@/configs/endpoints';


const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach interceptors
api.interceptors.request.use(requestInterceptor);
api.interceptors.response.use(
  responseInterceptor.success,
  responseInterceptor.error
);

export default api;
